module.exports = __webpack_public_path__ + "img/Teodor.1c61e387.png";